import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ActionResponse } from 'src/app/models/action-response';
import { ServiceAlias } from 'src/app/models/service';
import { ReplaceBillingitemsDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-billingitems-wizard/activation-step/replacebillingitems-due-date-info';
import { ReplaceBillingitemsInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-billingitems-wizard/init-step/init-step';
import * as fromReplaceBillingitemsWizard from './reducer';
import { State } from './state';

export const selectReplaceBillingitemsWizardState = createFeatureSelector<State>(
  fromReplaceBillingitemsWizard.replaceBillingitemsWizardFeatureKey,
);

export const selectInitStep = createSelector(
  selectReplaceBillingitemsWizardState,
  (state: State): ReplaceBillingitemsInitStepV26 => state.initStep,
);

export const selectDueDateStep = createSelector(
  selectReplaceBillingitemsWizardState,
  (state: State): ReplaceBillingitemsDueDatesV26 => state.dueDatesStep,
);

export const selectServicesStep = createSelector(selectReplaceBillingitemsWizardState, (state: State): ServiceAlias[] => state.serviceStep);

export const selectReplaceBillingitemsState = createSelector(
  selectReplaceBillingitemsWizardState,
  (state: State): ActionResponse => state.response,
);

export const selectErrorMessage = createSelector(selectReplaceBillingitemsWizardState, (state: State): string => state.errorMessage);
